import "./Filter.css";
import { useState } from "react";
import { FilterCategory } from "../../../types";
import { Badge } from "ui-kit";
import type { Keys } from "i18n/locales/types";
import { _, _any } from "i18n";
import { useGameStore } from "../../../store";

interface BadgeProps {
	label: string;
	key: string;
	value: string;
}

export function AppliedFilters() {
	const { filteredFilterValues, setFilterValues, setFilteredFilterValues, eventFilter } = useGameStore();

	const badges: BadgeProps[] = [];
	const [showAll, setShowAll] = useState(false);

	const handleClick = (badge: BadgeProps) => {
		const mutatedFilterValues = eventFilter.mutateFilterValues(filteredFilterValues, badge.key, badge.value);
		setFilteredFilterValues(mutatedFilterValues);
		setFilterValues(mutatedFilterValues);
	};

	// biome-ignore lint/complexity/noForEach: <explanation>
	eventFilter?.flatFilterViews.forEach((fw) => {
		const fv = filteredFilterValues.find((f) => f.key === fw.key);

		if (fv !== undefined) {
			const filterView = eventFilter.getFilterViewByFilterValue(fv);
			const filterCategory = eventFilter.getFilterCategory(fv.key);

			if ([FilterCategory.Event, FilterCategory.EventGroup, FilterCategory.Team, FilterCategory.Period].includes(filterCategory)) {
				if (filterView?.label) {
					badges.push({
						label: filterView.label,
						key: filterView.key,
						value: fv.value[0],
					});
				}

				if (filterCategory === FilterCategory.Event) {
					for (const nfv of eventFilter.getNestedFilterValues(fv.key, filteredFilterValues)) {
						if (eventFilter.getFilterCategory(nfv.key) === FilterCategory.EventFlag) {
							const flagView = eventFilter.getFilterViewByFilterValue(nfv);
							if (flagView?.options) {
								for (const val of nfv.value) {
									const flagLabel = flagView.options?.get(val);
									if (flagLabel) {
										badges.push({
											label: `${_(flagView.label as keyof Keys)}: ${_(flagLabel as keyof Keys).toLowerCase()}`,
											key: flagView.key,
											value: val,
										});
									}
								}
							}
						}
					}
				}
			}

			if ([FilterCategory.HighlightItem, FilterCategory.Player].includes(filterCategory) && filterView?.options) {
				filterView.options.forEach((value, key) => {
					if (fv.value.includes(key)) {
						badges.push({
							label: value,
							key: fv.key,
							value: key,
						});
					}
				});
			}

			if (filterCategory === FilterCategory.HighlightGroup) {
				badges.push({
					label: "highlight",
					key: fv.key,
					value: "highlight",
				});
			}
		}
	});

	const badgesToShow = showAll ? badges : badges.slice(0, 3);
	const hasMoreThanFive = badges.length > 3;

	return (
		<div className="to-use-somewhere">
			{badgesToShow.map((badge, index) => (
				<span key={`${index}-${badge.label}`} style={{ display: "inline-block", margin: "0 5px 5px 0" }}>
					<Badge size="xs" variant="info" label={_any(badge.label)} onClick={() => handleClick(badge)} />
				</span>
			))}
			{hasMoreThanFive && (
				<button type="button" className="showMoreButton" onClick={() => setShowAll((prev) => !prev)}>
					{showAll ? _("label.nationalLeagues.less") : _("label.showMore")}
				</button>
			)}
		</div>
	);
}
